// PostgREST returns at most the project's max-rows (Supabase default 1000) per
// request and silently drops the rest (HTTP 206, no error); an explicit
// .limit() above the cap is capped too. Pages through with .range() until a
// short page comes back. Returns { data, error } like a supabase-js query.
//
// buildQuery must return a fresh query on every call, ordered by a unique key
// (e.g. .order('id'), or .order('voteDate').order('id')) so pages neither
// overlap nor skip rows. PAGE must not exceed the cap, or the first page would
// look short and end the loop early.
const PAGE = 1000;

export async function fetchAllRows(buildQuery) {
  const rows = [];
  for (let from = 0; ; from += PAGE) {
    const { data, error } = await buildQuery().range(from, from + PAGE - 1);
    if (error) return { data: null, error };
    rows.push(...(data || []));
    if (!data || data.length < PAGE) return { data: rows, error: null };
  }
}
